import React from 'react';
import { Select as CimpressSelect, SelectProps } from '@cimpress/react-components';
import { useSelectPortal } from '../contexts/select-portal';

// tslint:disable-next-line:variable-name
export const Select = ({ tether, ...props }: SelectProps) => {
  const portalRef = useSelectPortal();

  return <CimpressSelect {...props} menuPortalTarget={portalRef && tether ? portalRef.current : undefined}/>;
};
